import { createContext, useContext } from "react";
import type { MediaController } from "../adapters/types";

export const MediaControllerContext = createContext<MediaController | null>(null);

export function useMediaControllerContext() {
  return useContext(MediaControllerContext);
}
